<script async setup>
import { defineProps } from "vue";

const props = defineProps({
    icon: {
        type: String,
        default: "",
    },
});
</script>

<template>
    <component :is="'kd-icon-' + props.icon" />
</template>
